
import styled from "styled-components";
import React from 'react';
import { AreaChart, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, Area } from 'recharts';
import MiniLoader from "../utils/MIniLoader";

const CustomChart = ({ title, chartData, loading }) => {

      return (
            <StyledOverviewChart className="h-100">
                  <div className="main-container">

                        <div className="d-flex justify-content-between gap-2">
                              <div className="d-flex gap-2">

                                    <h4 className="mb-4 grey-bold-text">
                                          {title}
                                    </h4>
                                    <MiniLoader
                                          load={loading}
                                    />
                              </div>

                        </div>
                        <ResponsiveContainer width="100%" height={350}>
                              <AreaChart
                                    width={500}
                                    height={300}
                                    data={chartData}
                                    margin={{
                                          top: 5,
                                          right: 30,
                                          left: 20,
                                          bottom: 5,
                                    }}
                              >
                                    <CartesianGrid strokeDasharray="3 3" />
                                    <XAxis dataKey="month" />
                                    <YAxis />
                                    <Tooltip />
                                    <Legend />
                                    <Area type="monotone" dataKey="sale" stroke="#667085" fill="#66708521" />
                                    <Area type="monotone" activeDot={{ r: 8 }} dataKey="expense" stroke="#FF0000" fill="#FF000021" />

                              </AreaChart>
                        </ResponsiveContainer>
                  </div>

                  {/* <Area type="monotone" dataKey="expense" stroke="#DBA362CC" fill="#dba36221" />
                                    <Area type="monotone" dataKey="expense" stroke="#FF0000" fill="#FF000021" />
                                    <Area type="monotone" dataKey="expense" stroke="#845EBC" fill="#845EBC21" /> */}

            </StyledOverviewChart>
      );
};

export default CustomChart;

const StyledOverviewChart = styled.div`


`;
